import { useState } from "react";
import Navbar from "../../components/shared/Navbar";

/* PNG ICONS */
import locationIcon from "../../assets/images/location.png";
import phoneIcon from "../../assets/images/call.png";
import emailIcon from "../../assets/images/email.png";
import clockIcon from "../../assets/images/time.png";
import AnimatedCTAOutline from "../../components/shared/AnimatedCTAOutline";
import { Toaster, toast } from "react-hot-toast";

/* HEADER PATTERN */
import headerLines from "../../assets/images/header-lines.png";

function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;

    // Keep all existing browser validations
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData(form);

      const response = await fetch(
        "https://formsubmit.co/ajax/swapnil@traveldesire.in",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success("Your inquiry has been submitted successfully!");
        form.reset();
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Unable to submit your inquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />

      {/* ================= NAVBAR ================= */}
      <Navbar bgColor="#001917" />

      <section className="relative bg-[#001917] overflow-hidden h-[210px] md:h-[270px]">
        <img
          src={headerLines}
          alt=""
          className="pointer-events-none absolute top-0 right-0 h-full w-auto opacity-90"
        />

        <div className="relative max-w-7xl mx-auto px-3 md:px-6 h-full flex items-end pb-6 md:pb-10">
          <h1 className="font-tiempos text-[36px] md:text-[52px] leading-[40px] md:leading-[62px] font-[500] text-white">
            Have <span className="text-[#1EEBD9]">Queries?</span>
          </h1>
        </div>
      </section>

      {/* ================= FORM SECTION ================= */}
      <section className="bg-white py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16">

            {/* ================= FORM ================= */}
            <div className="md:col-span-2">

              <form
                onSubmit={handleSubmit}
                className="space-y-6 font-manrope"
              >

                {/* ================= FormSubmit Configuration ================= */}

                <input
                  type="hidden"
                  name="_subject"
                  value="New Travel Inquiry - TravelDesire"
                />

                <input
                  type="hidden"
                  name="_captcha"
                  value="false"
                />

                <input
                  type="hidden"
                  name="_template"
                  value="table"
                />

                {/* ================= FULL NAME ================= */}
                <div>
                  <label className="block text-[16px] font-manrope font-[600] text-[#011715] mb-1">
                    Full Name<span className="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    name="Full Name"
                    required
                    placeholder="Your name"
                    className="w-full h-[48px] rounded-[12px] border border-[#7DBAB366] px-5 text-[14px] font-manrope font-[400] text-[#033733] outline-none focus:border-[#A3FEF8] focus:bg-[#F1FFFE]"
                  />
                </div>

                {/* ================= PHONE + DATE ================= */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                  {/* ================= PHONE ================= */}
                  <div>
                    <label className="block text-[16px] font-[600] font-manrope text-[#011715] mb-1">
                      Phone Number (Whatsapp)
                      <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="tel"
                      name="Phone Number"
                      required
                      inputMode="numeric"
                      autoComplete="tel"
                      maxLength={15}
                      placeholder="+91 98765 43210"
                      pattern="^(\+91[\s-]?)?[6-9]\d{9}$"
                      title="Please enter a valid 10-digit Indian mobile number"

                      onInput={(e) => {
                        // Allow only digits, +, spaces and hyphens
                        e.target.value = e.target.value.replace(
                          /[^0-9+\s-]/g,
                          ""
                        );

                        // Prevent multiple + signs
                        if (e.target.value.indexOf("+") > 0) {
                          e.target.value =
                            e.target.value.replace(/\+/g, "");
                        }
                      }}

                      onBlur={(e) => {
                        const value = e.target.value.trim();

                        // Remove +91, spaces and hyphens for validation
                        const mobile = value
                          .replace(/^\+91[\s-]?/, "")
                          .replace(/[\s-]/g, "");

                        if (!/^[6-9]\d{9}$/.test(mobile)) {
                          e.target.setCustomValidity(
                            "Please enter a valid 10-digit Indian mobile number."
                          );
                        } else {
                          e.target.setCustomValidity("");
                        }
                      }}

                      onInputCapture={(e) => {
                        e.target.setCustomValidity("");
                      }}

                      className="w-full h-[48px] rounded-[12px] border border-[#7DBAB366] px-5 text-[14px] font-manrope font-[400] text-[#033733] outline-none focus:border-[#A3FEF8] focus:bg-[#F1FFFE]"
                    />
                  </div>

                  {/* ================= DATE ================= */}
                  <div>
                    <label className="block text-[16px] font-manrope font-[600] text-[#011715] mb-1">
                      Preferred Date of Travel
                      <span className="text-red-500">*</span>
                    </label>

                    <input
                      type="date"
                      name="Preferred Date of Travel"
                      required
                      min={new Date().toISOString().split("T")[0]}
                      className="w-full h-[48px] rounded-[12px] border border-[#7DBAB366] px-5 text-[14px] text-[#033733] bg-white font-[400] font-manrope outline-none focus:border-[#A3FEF8] focus:bg-[#F1FFFE]"
                    />
                  </div>

                </div>

                {/* ================= DESTINATION ================= */}
                <div>
                  <label className="block text-[16px] font-manrope font-[600] text-[#011715] mb-1">
                    Destination<span className="text-red-500">*</span>
                  </label>

                  <input
                    type="text"
                    name="Destination"
                    required
                    placeholder="Enter your destination"
                    className="w-full h-[48px] rounded-[12px] border border-[#7DBAB366] px-5 text-[14px] font-manrope font-[400] text-[#033733] outline-none focus:border-[#A3FEF8] focus:bg-[#F1FFFE]"
                  />
                </div>

                {/* ================= NO OF PAX ================= */}
                <div>
                  <label className="block text-[16px] font-manrope font-[600] text-[#011715] mb-1">
                    No of PAX<span className="text-red-500">*</span>
                  </label>

                  <input
                    type="number"
                    name="No of PAX"
                    required
                    min="1"
                    placeholder="Enter number of travellers"
                    className="w-full h-[48px] rounded-[12px] border border-[#7DBAB366] px-5 text-[14px] font-manrope font-[400] text-[#033733] outline-none focus:border-[#A3FEF8] focus:bg-[#F1FFFE]"
                  />
                </div>

                {/* ================= DISCLAIMER ================= */}
                <p className="text-[12px] leading-[18px] font-inter font-[400] text-[#717171] text-center md:text-left">
                  By submitting this form, you agree to our privacy policy and
                  terms of service.
                </p>

                {/* ================= SUBMIT BUTTON ================= */}
                <div className="flex justify-center md:justify-end pt-4 md:pt-6">

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="disabled:opacity-70 disabled:cursor-not-allowed"
                  >
                    <AnimatedCTAOutline
                      defaultText={
                        isSubmitting
                          ? "Sending..."
                          : "Send Inquiry Now!"
                      }
                      hoverText="Plan My Trip!"
                      className="
                        flex items-center justify-center
                        w-[210px]
                        h-[48px] md:h-[52px]
                        rounded-full
                        border border-[#0FA297]
                        text-[#001917]
                        bg-[#06D5C6]
                        hover:border-[#06D5C6]
                        hover:bg-white
                        transition-all duration-300
                      "
                    />
                  </button>

                </div>

              </form>
            </div>

            {/* ================= CONTACT INFO ================= */}
            <div className="rounded-[20px] border border-[1px] border-[#D5FB93] p-8 py-3 h-fit">

              <h3 className="font-tiempos text-[24px] font-[500] text-[#121212] mb-6">
                Contact Information
              </h3>

              <ul className="space-y-6 font-manrope text-[14px] text-[#4B5563]">

                {/* Office Address */}
                <li className="flex gap-4">
                  <img
                    src={locationIcon}
                    className="w-12 h-12"
                    alt=""
                  />

                  <div>
                    <p className="font-manrope font-[700] text-[18px] text-[#121212]">
                      Office Address
                    </p>

                    <p className="mt-1 font-manrope text-[14px] font-[500] text-[#4A5565]">
                      Office No 510, 10 Biz Park, near Symbiosis Law School
                      Road, Mhada Colony, Viman Nagar, Pune, Maharashtra 411014
                    </p>
                  </div>
                </li>

                {/* Phone */}
                <li className="flex gap-4">
                  <img
                    src={phoneIcon}
                    className="w-12 h-12"
                    alt=""
                  />

                  <div>
                    <p className="font-manrope font-[700] text-[18px] text-[#121212]">
                      Phone
                    </p>

                    <p className="mt-1 font-manrope text-[14px] font-[500] text-[#4A5565]">
                      +91 98765 43210
                    </p>

                    <p className="font-manrope text-[14px] font-[500] text-[#4A5565]">
                      +91 8308315775
                    </p>
                  </div>
                </li>

                {/* Email */}
                <li className="flex gap-4">
                  <img
                    src={emailIcon}
                    className="w-12 h-12"
                    alt=""
                  />

                  <div>
                    <p className="font-manrope font-[700] text-[18px] text-[#121212]">
                      Email
                    </p>

                    <p className="mt-1 font-manrope text-[14px] font-[500] text-[#4A5565]">
                      <a href="mailto:sales@traveldesire.in">
                        sales@traveldesire.in
                      </a>
                    </p>
                  </div>
                </li>

                {/* Business Hours */}
                <li className="flex gap-4">
                  <img
                    src={clockIcon}
                    className="w-12 h-12"
                    alt=""
                  />

                  <div>
                    <p className="font-manrope font-[700] text-[18px] text-[#121212]">
                      Business Hours
                    </p>

                    <p className="mt-1 font-manrope text-[14px] font-[500] text-[#4A5565]">
                      Mon – Sat: 9:00 AM – 8:00 PM
                    </p>

                    <p className="font-manrope text-[14px] font-[500] text-[#4A5565]">
                      Sunday: 10:00 AM – 6:00 PM
                    </p>
                  </div>
                </li>

              </ul>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;